import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const List = ({
  size,
  type,
  theme,
  className,
  dataTestId = "list-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M2 4C2.55228 4 3 3.55228 3 3C3 2.44772 2.55228 2 2 2C1.44772 2 1 2.44772 1 3C1 3.55228 1.44772 4 2 4Z" />
    <path d="M6 2.33333C5.63181 2.33333 5.33333 2.63181 5.33333 3C5.33333 3.36819 5.63181 3.66667 6 3.66667H14C14.3682 3.66667 14.6667 3.36819 14.6667 3C14.6667 2.63181 14.3682 2.33333 14 2.33333H6Z" />
    <path d="M6 7.33333C5.63181 7.33333 5.33333 7.63181 5.33333 8C5.33333 8.36819 5.63181 8.66667 6 8.66667H14C14.3682 8.66667 14.6667 8.36819 14.6667 8C14.6667 7.63181 14.3682 7.33333 14 7.33333H6Z" />
    <path d="M5.33333 13C5.33333 12.6318 5.63181 12.3333 6 12.3333H14C14.3682 12.3333 14.6667 12.6318 14.6667 13C14.6667 13.3682 14.3682 13.6667 14 13.6667H6C5.63181 13.6667 5.33333 13.3682 5.33333 13Z" />
    <path d="M3 8C3 8.55229 2.55228 9 2 9C1.44772 9 1 8.55229 1 8C1 7.44772 1.44772 7 2 7C2.55228 7 3 7.44772 3 8Z" />
    <path d="M2 14C2.55228 14 3 13.5523 3 13C3 12.4477 2.55228 12 2 12C1.44772 12 1 12.4477 1 13C1 13.5523 1.44772 14 2 14Z" />
  </SVGIcon>
);
